/* global localStorage */
import { createTypes } from "redux-action-types";
import api from "../api";
import config from "../config";

export const types = createTypes(
  "fridge/auth/",
  "OK",
  "FAIL",
  "LOGIN_PENDING",
  "LOGIN",
  "LOGOUT",
  "RESET_PASSWORD_FAIL",
  "RESET_PASSWORD",
  "CHANGE_PASSWORD"
);

export async function checkLogin(state, dispatch) {
  if (state.loggedIn === true) {
    return true;
  }

  try {
    // perhaps replace this with cookies?
    api.options.token = localStorage.getItem("accessToken");
    const account = await api.get("account");
    if (account.error && account.error.code !== "404")
      throw new Error("Not logged in");
    const sites = await api.get("sites");

    dispatch({ type: types.OK, data: { account, sites } });
  } catch (err) {
    console.log(err);
    dispatch({ type: types.FAIL });
    return false;
  }

  return true;
}

export async function checkEmail(email) {
  try {
    const res = await api.post("account/check", { email });
    if (res.error) throw new Error(res.error.message);
    return true;
  } catch (e) {
    return false;
  }
}

export const login = async (email, password, redirect = "/", dispatch) => {
  try {
    dispatch({ type: types.LOGIN_PENDING });
    localStorage.removeItem("accessToken");
    const { token, error } = await api.post("auth/login", {
      email: email.toLowerCase(),
      password,
      tokenName: `Fridge (${config.browser.name})`,
    });
    if (error) throw new Error(error.message);
    localStorage.setItem("accessToken", token.token);
    // document.cookie = 'logged_in=true; domain=.fridgecms.com'
    window.location.replace(redirect);
    dispatch({ type: types.LOGIN });
  } catch (err) {
    dispatch({ type: types.FAIL, error: err.message });
  }
};

export const logout = () => {
  localStorage.removeItem("accessToken");
  document.cookie = "";
  api.options.token = null;
  return { type: types.LOGOUT };
};

export const signup = async (values) => {
  await api.post("account", values);
  localStorage.removeItem("accessToken");
  document.cookie = "";
};

export const resetPassword = async (email) => {
  const { error } = await api.post("auth/reset", { email });
  return error
    ? { type: types.RESET_PASSWORD_FAIL, error }
    : { type: types.RESET_PASSWORD };
};

export const changePassword = async (data) => {
  const { error } = await api.put("auth/password", data);
  return error
    ? { type: types.RESET_PASSWORD_FAIL, error }
    : { type: types.CHANGE_PASSWORD };
};



// WEBPACK FOOTER //
// ./app/actions/auth.js